// test1728
(1728 && 0);
